<template>
  <div class="mInput-container" :class="{
    isMobile: isMobile()
  }">
    <div class="sys-max-width">

      <div class="m-title flex justify-center">{{ title }}</div>
      <div class="title flex justify-center">观看图片上传</div>

      <el-form :model="form" :rules="formRules" ref="form" label-width="100px" class="demo-ruleForm">
        <el-form-item prop="name">
          <uploadComponent
            v-model="form.files"
            :imageLimit="10"
          />
        </el-form-item>
      </el-form>

      <div class="button-box flex justify-center">
        <el-button :loading="loading" @click="submitHandle" type="primary">提交</el-button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { inputInfo } from '@/api/video'
import uploadComponent from '@/components/upload'
import { isMobile } from '@/utils/index'

export default {
  components: {
    uploadComponent
  },
  data() {
    return {
      form: {
        video_code: '',
        object_code: '',
        files: [],

        title: ''
      },
      formRules: {
      },

      loading: false
    }
  },
  mounted() {

  },
  methods: {
    isMobile,

    submitHandle() { // 编辑提交

      if (this.form.files.length === 0) {
        this.$message.error('请先上传照片')
        return
      }


      this.$refs['form'].validate(async valid => {
        if (valid) {
          this.loading = true

          console.log(2222222)
          console.log(this.form)

          try {
            await inputInfo(this.form)

            this.form.files = []

            this.loading = false

            this.$message.success('操作成功')
          } catch (error) {
            this.loading = false
          }
        } else {
          return false
        }
      })
    },
  },
  created() {
    const { video_code, object_code, title } = this.$route.query

    this.form.video_code = video_code
    this.form.object_code = object_code

    this.title = title ? decodeURIComponent(title) : ''
  }
}
</script>

<style lang="scss">
.mInput-container {
  background: $bg;
  height: calc(100vh - 72px);

  .m-title {
    font-size: 18px;
    margin-bottom: 5px;
  }

  .el-form-item {
    display: flex;
    justify-content: center;
    .el-form-item__content {
      margin-left: 0 !important;
    }

    // .el-upload-list {
    //   display: flex;
    //   flex-wrap: wrap;
    // }
  }


  .button-box {
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    height: 50px;

    .el-button {
      width: 100%;
    }
  }

  &.isMobile {
    .sys-max-width {
      padding: 1.5rem;
    }
  }

  .sys-max-width {
    padding: 49px 0px 71px;

    .title {
      font-size: 16px;
      margin-bottom: 10px;


    }
  }
}
</style>
